import {
  IconArrowBackUp,
  IconArrowBackUpDouble,
  IconTrash,
} from "@tabler/icons-react";
import { PropsWithChildren } from "react";

import css from "./EditItemToolbar.module.scss";

type SimpleButtonProps = {
  onClick?: () => void;
};

export type UndoButtonProps = SimpleButtonProps;
export function UndoButton(props: UndoButtonProps) {
  return (
    <button style={{ backgroundColor: "transparent" }} onClick={props.onClick}>
      <IconArrowBackUp style={{ color: "white" }} />
    </button>
  );
}

export type UndoAllButtonProps = SimpleButtonProps;
export function UndoAllButton(props: UndoAllButtonProps) {
  return (
    <button style={{ backgroundColor: "transparent" }} onClick={props.onClick}>
      <IconArrowBackUpDouble style={{ color: "white" }} />
    </button>
  );
}

export type DeleteButtonProps = SimpleButtonProps;
export function DeleteButton(props: DeleteButtonProps) {
  return (
    <button
      onClick={props.onClick}
      style={{
        backgroundColor: "transparent",
      }}
    >
      <IconTrash className="fg-danger" />
    </button>
  );
}

export type EditItemToolbarProps = PropsWithChildren & {
  slots?: {
    start?: React.ReactNode;
    end?: React.ReactNode;
  };
};
export function EditItemToolbar(props: EditItemToolbarProps) {
  return (
    <div className={css.EditItemToolbar}>
      <div
        className={css.EditItemToolbarButtons}
        style={{ justifyContent: "start" }}
      >
        {props.slots?.start}
      </div>
      <div
        className={css.EditItemToolbarButtons}
        style={{ justifyContent: "center" }}
      >
        {props.children}
      </div>
      <div
        className={css.EditItemToolbarButtons}
        style={{ justifyContent: "end" }}
      >
        {props.slots?.end}
      </div>
    </div>
  );
}
